export const TOS_NAMESPACE = 'terms-of-service'

export interface ToSNamespace {
  readonly commands: {
    singleFireAccept(): void
    singleFireRefuse(): void
  }
}
